import { gql } from "lib/apolloClient";

export const createGlobalCategoryMutation = gql`
  mutation createGlobalCategory($input: CreateGlobalCategoryInput!) {
    planner {
      createGlobalCategory(input: $input) {
        isSuccess
      }
    }
  }
`;

export const updateGlobalCategoryMutation = gql`
  mutation updateGlobalCategory($input: [UpdateGlobalCategoryInput!]!) {
    planner {
      updateGlobalCategory(input: $input) {
        isSuccess
      }
    }
  }
`;

export const deleteGlobalCategoriesByIdsMutation = gql`
  mutation deleteGlobalCategoriesByIds($ids: [ID!]) {
    planner {
      deleteGlobalCategoryById(ids: $ids) {
        isSuccess
      }
    }
  }
`;

export const createGradingConfiguration = gql`
  mutation CreateGradingConfiguration(
    $input: CreateGradingConfigurationInput!
  ) {
    planner {
      createGradingConfigurationTemplate(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const bulkUpdateGradingConfigurationMutation = gql`
  mutation bulkUpdateGradingConfigurationTemplate(
    $input: BulkUpdateGradingConfigurationInput!
  ) {
    planner {
      bulkUpdateGradingConfigurationTemplate(input: $input) {
        isSuccess
      }
    }
  }
`;

export const setGradingMethodologyMutation = gql`
  mutation setGradingMethodology($input: [SetGradingMethodologyInput!]!) {
    planner {
      setGradingMethodology(input: $input) {
        isSuccess
      }
    }
  }
`;

export const bulkImportGradeScalesMutation = gql`
  mutation bulkImportGradeScales($input: BulkImportGradeScalesInput!) {
    planner {
      bulkImportGradeScales(input: $input) {
        isSuccess
      }
    }
  }
`;

export const createGradeScaleMutation = gql`
  mutation createGradeScale($input: CreateGradeScaleInput!) {
    planner {
      createGradeScale(input: $input) {
        isSuccess
        response {
          id
        }
      }
    }
  }
`;

export const updateGradeScaleMutation = gql`
  mutation updateGradeScale($input: UpdateGradeScaleInput!) {
    planner {
      updateGradeScale(input: $input) {
        isSuccess
      }
    }
  }
`;

export const deleteGradeScaleMutation = gql`
  mutation deleteGradeScale($input: [DeleteGradeScaleInput!]!) {
    planner {
      deleteGradeScale(input: $input) {
        isSuccess
      }
    }
  }
`;

export const createGradingConfigurationForGradeScalesMutation = gql`
  mutation createGradingConfigurationForGradeScales(
    $input: CreateGradingConfigurationForGradeScaleInput!
  ) {
    planner {
      createGradingConfigurationForGradeScales(input: $input) {
        isSuccess
        __typename
      }
      __typename
    }
  }
`;

export const importIBDefinedGradeScaleMutation = gql`
  mutation importIBDefinedGradeScale($input: ImportIBDefinedGradeScaleInput!) {
    planner {
      importIBDefinedGradeScale(input: $input) {
        isSuccess
      }
    }
  }
`;

export const bulkImportFinalGradeScaleMutation = gql`
  mutation bulkImportFinalGradeScale($input: BulkImportFinalGradeScaleInput!) {
    planner {
      bulkImportFinalGradeScale(input: $input) {
        isSuccess
      }
    }
  }
`;

export const updateGpaInclusionMapMutation = gql`
  mutation updateGpaInclusionMap($input: GPAInclusionMapInput) {
    platform {
      updateGPAInclusionMap(input: $input)
    }
  }
`;
